<template>
  <div id="app">
    <el-container>
      <!-- ===== 顶部导航栏 ===== -->
      <el-header height="60px" class="app-header">
        <el-menu
          :default-active="$route.path"
          mode="horizontal"
          @select="onMenuSelect"
          active-text-color="#1989fa"
          text-color="#409eff"
          background-color="#ffffff"
          class="app-nav"
        >
          <!-- Logo -->
          <el-menu-item index="/index" class="nav-logo">
            <el-image :src="logoUrl" style="width:80px" fit="contain"></el-image>
          </el-menu-item>

          <!-- 主导航 -->
          <!-- <el-menu-item index="/">任务招募 · 嵌字</el-menu-item> -->
          <el-menu-item index="/fy">任务招募 · 嵌字</el-menu-item>
          <el-menu-item>
            <a
              href="https://manhua.zaimanhua.com/dynamic/%E7%BB%BF%E8%8C%B6%E6%B1%89%E5%8C%96%E7%BB%84"
              target="_blank"
              class="nav-link"
            >跳转再漫画</a>
          </el-menu-item>

          <!-- 发布任务按钮组（右侧） -->
          <el-menu-item class="nav-publish">
            <!-- <el-button type="primary" size="mini" @click="openPublish('zmb')">发布嵌字任务</el-button> -->
            <el-button type="success" size="mini" style="margin-left:8px" @click="openPublish('fy')">发布嵌字任务</el-button>
          </el-menu-item>
        </el-menu>

        <div class="mobile-publish-wrap">
          <el-button type="success" size="mini" @click="openPublish('fy')">发布任务</el-button>
        </div>
      </el-header>

      <!-- ===== 页面内容 ===== -->
      <el-main class="app-main">
        <router-view />
      </el-main>
    </el-container>

    <!-- ===== 发布任务弹窗 ===== -->
      <el-dialog
      :title="publishType === 'zmb' ? '发布嵌字任务' : '发布嵌字任务'"
      :visible.sync="publishDialogVisible"
      width="560px"
      top="8vh"
        custom-class="publish-dialog"
      :before-close="onPublishClose"
    >
      <el-form
        ref="publishForm"
        :model="form"
        :rules="formRules"
        label-width="120px"
        size="small"
      >
        <!-- 漫画名 + 搜索跳转 -->
        <el-form-item label="漫画名" prop="title">
          <el-input v-model="form.title" placeholder="准确的漫画名" style="width:100%">
            <template slot="append">
              <a :href="`https://manhua.zaimanhua.com/dynamic/${form.title}`" target="_blank">搜索</a>
            </template>
          </el-input>
        </el-form-item>

        <!-- 漫画网址 + 自动获取封面 -->
        <el-form-item label="漫画网址" prop="mg_url">
          <div class="inline-field-row">
            <el-input v-model="form.mg_url" placeholder="漫画列表页网址" class="inline-main-input"></el-input>
            <el-button size="small" type="primary" class="inline-action-btn" :loading="fetchingCover" @click="autoFetchCover">获取封面</el-button>
          </div>
        </el-form-item>
        <div v-if="fetchedComicInfo" class="fetched-comic-info">
          <el-image
            v-if="fetchedComicInfo.cover"
            :src="fetchedComicInfo.cover"
            class="fetched-cover"
            fit="cover"
          ></el-image>
          <div class="fetched-comic-meta">
            <div class="fetched-comic-title">{{ fetchedComicInfo.title || '未获取到漫画名' }}</div>
            <div class="fetched-comic-line">漫画 ID：{{ fetchedComicInfo.id || '-' }}</div>
            <div class="fetched-comic-line">最新章节：{{ fetchedComicInfo.last_update_chapter_name || '-' }}</div>
            <div class="fetched-comic-line">更新时间：{{ formatUpdateTime(fetchedComicInfo.last_updatetime) }}</div>
          </div>
        </div>
        <p class="form-tip">△ 若自动获取失败请手动填写下方封面图 URL，或上传到<a href="https://www.hd-r.cn/" target="_blank">公共图床</a>后粘贴</p>

        <!-- 封面图 URL + 预览 -->
        <el-form-item label="封面图URL" prop="pic_url">
          <div class="inline-field-row cover-row">
            <el-input v-model="form.pic_url" placeholder="封面图直链" class="inline-main-input"></el-input>
            <el-image
              v-if="form.pic_url"
              :src="form.pic_url"
              class="inline-cover-preview"
              fit="cover"
            ></el-image>
          </div>
        </el-form-item>

        <!-- 难度 -->
        <el-form-item label="难度" prop="hard">
          <el-rate v-model="form.hard" :max="5"></el-rate>
        </el-form-item>

        <!-- 话数 & 页数 -->
        <el-form-item label="第几话" prop="HuaSu">
          <div class="episode-row">
            <el-input v-model="form.HuaSu" placeholder="数字" class="episode-input"></el-input>
            <span class="episode-text">话，共</span>
            <el-input v-model="form.P" placeholder="数字" class="episode-input"></el-input>
            <span class="episode-text">P</span>
          </div>
        </el-form-item>

        <!-- 交稿时间 -->
        <el-form-item label="交稿时间（天）" prop="DDL">
          <el-input v-model="form.DDL" placeholder="几天后交稿，如：7"></el-input>
        </el-form-item>

        <!-- 发布者 -->
        <el-form-item label="发布者署名；" prop="helper">
          <el-input v-model="form.helper" placeholder="你在组内的署名，也可以通过此处写些话"></el-input>
        </el-form-item>

        <!-- 分组（note 组成部分） -->
        <el-form-item label="分组" prop="group">
          <el-input v-model="form.group" placeholder="例如：绿茶、萌木"></el-input>
        </el-form-item>

        <!-- QQ号（note 组成部分） -->
        <el-form-item label="QQ号" prop="qq">
          <el-input v-model="form.qq" placeholder="仅用于接单弹窗展示"></el-input>
        </el-form-item>

        <!-- 发布秘钥 -->
        <el-form-item label="发布秘钥" prop="need_time">
          <el-input v-model="form.need_time" placeholder="见发布群" show-password></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="publishDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="publishing" @click="submitPublish">确认发布</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { publishZmbTask, publishFyTask, fetchCoverUrl } from '@/api/index'

const EMPTY_FORM = () => ({
  title: '',
  mg_url: '',
  pic_url: '',
  hard: 0,
  HuaSu: '',
  P: '',
  DDL: '',
  helper: '',
  group: '',
  qq: '',
  need_time: ''
})

export default {
  name: 'App',

  data() {
    return {
      logoUrl: 'http://doc.gtea.icu/img/logo.png',

      // 发布弹窗
      publishDialogVisible: false,
      publishType: 'zmb',    // 'zmb' | 'fy'
      form: EMPTY_FORM(),
      fetchedComicInfo: null,
      publishing: false,
      fetchingCover: false,

      formRules: {
        title:    [{ required: true, message: '请填写漫画名', trigger: 'blur' }],
        hard:     [{ type: 'number', required: true, min: 1, message: '请选择难度星级', trigger: 'change' }],
        HuaSu:    [{ required: true, message: '请填写话数', trigger: 'blur' }],
        P:        [{ required: true, message: '请填写页数', trigger: 'blur' }],
        DDL:      [{ required: true, message: '请填写交稿天数', trigger: 'blur' }],
        helper:   [{ required: true, message: '请填写发布者署名', trigger: 'blur' }],
        group:    [{ required: true, message: '请填写分组', trigger: 'blur' }],
        qq:       [{ required: true, message: '请填写 QQ 号', trigger: 'blur' }],
        need_time:[{ required: true, message: '请填写发布秘钥', trigger: 'blur' }]
      }
    }
  },

  methods: {
    onMenuSelect(key) {
      if (this.$route.path !== key) {
        this.$router.push(key)
      }
    },

    /** 打开发布弹窗 */
    openPublish(type) {
      this.publishType = type
      this.form = EMPTY_FORM()
      this.fetchedComicInfo = null
      this.publishDialogVisible = true
      this.$nextTick(() => {
        this.$refs.publishForm && this.$refs.publishForm.clearValidate()
      })
    },

    onPublishClose(done) {
      this.$confirm('确认关闭？').then(() => done()).catch(() => {})
    },

    /** 自动获取漫画信息 */
    async autoFetchCover() {
      const mgUrl = this.form.mg_url.trim()
      if (!mgUrl) {
        this.$message.warning('请先填写漫画网址')
        return
      }
      this.fetchingCover = true
      try {
        const res = await fetchCoverUrl(mgUrl)
        const comicInfo = res.data || {}

        if (!comicInfo.cover && !comicInfo.title) {
          throw new Error('EMPTY_COMIC_INFO')
        }

        this.fetchedComicInfo = comicInfo
        this.form.title = comicInfo.title || this.form.title
        this.form.pic_url = comicInfo.cover || this.form.pic_url
        this.$message.success('漫画信息获取成功，已自动填充表单')
      } catch (e) {
        this.fetchedComicInfo = null
        if (e && (e.message === 'INVALID_COMIC_URL' || e.message === 'EMPTY_URL')) {
          this.$message.error('漫画网址格式不正确，请粘贴再漫画详情页链接')
          return
        }
        this.$message.error('自动获取失败，请手动填写漫画名和封面图 URL')
      } finally {
        this.fetchingCover = false
      }
    },

    formatUpdateTime(timestamp) {
      if (!timestamp) {
        return '-'
      }

      const date = new Date(Number(timestamp) * 1000)
      if (Number.isNaN(date.getTime())) {
        return '-'
      }

      const pad = value => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
    },

    /** 提交发布 */
    submitPublish() {
      this.$refs.publishForm.validate(async valid => {
        if (!valid) return
        this.publishing = true
        try {
          const fn = this.publishType === 'zmb' ? publishZmbTask : publishFyTask
          const { group, qq, ...payload } = this.form
          payload.note = JSON.stringify({ group: group.trim(), qq: qq.trim() })
          await fn(payload)
          this.$message.success('任务发布成功！')
          this.publishDialogVisible = false
          this.$router.go(0)
        } catch (e) {
          this.$message.error('发布失败，请检查秘钥是否正确')
        } finally {
          this.publishing = false
        }
      })
    }
  }
}
</script>

<style>
body { margin: 0; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; }

.app-header {
  padding: 0;
  border-bottom: 1px solid #ebeef5;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  overflow: hidden;
  position: relative;
}

.app-nav {
  height: 60px;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

.app-nav::-webkit-scrollbar {
  height: 0;
}

.nav-logo {
  padding: 0 12px;
}

.nav-link {
  color: #409eff;
  text-decoration: none;
}

.nav-publish {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.mobile-publish-wrap {
  display: none;
}

.app-main {
  min-height: calc(100vh - 60px);
  background: #f5f7fa;
  padding: 16px;
}

.form-tip {
  margin: -8px 0 8px 120px;
  font-size: 12px;
  color: #f56c6c;
}

.form-tip a {
  color: #409eff;
}

.fetched-comic-info {
  margin: -4px 0 12px 120px;
  padding: 10px;
  display: flex;
  align-items: flex-start;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #f9fbff;
}

.fetched-cover {
  width: 72px;
  height: 96px;
  border-radius: 4px;
  flex-shrink: 0;
  background: #f5f7fa;
}

.fetched-comic-meta {
  margin-left: 12px;
  min-width: 0;
  color: #606266;
  font-size: 12px;
  line-height: 1.7;
}

.fetched-comic-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  word-break: break-all;
}

.fetched-comic-line {
  word-break: break-all;
}

.inline-field-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.inline-main-input {
  flex: 1;
  min-width: 0;
}

.inline-action-btn {
  flex-shrink: 0;
}

.inline-cover-preview {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  flex-shrink: 0;
}

.episode-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.episode-input {
  width: 120px;
}

.episode-text {
  color: #999;
}

@media (max-width: 768px) {
  .app-header {
    padding-right: 86px;
  }

  .app-main {
    padding: 8px;
  }

  .nav-logo {
    padding: 0 6px;
  }

  .nav-publish {
    display: none !important;
  }

  .mobile-publish-wrap {
    display: block;
    position: absolute;
    right: 8px;
    top: 14px;
    z-index: 3;
  }

  .publish-dialog {
    width: 94% !important;
    margin-top: 0 !important;
  }

  .publish-dialog .el-dialog__body {
    padding: 16px 12px;
  }

  .publish-dialog .el-form-item {
    margin-bottom: 14px;
  }

  .publish-dialog .el-form-item__label,
  .publish-dialog .el-form-item__content {
    float: none;
    width: 100% !important;
    margin-left: 0 !important;
    text-align: left;
    line-height: 1.6;
  }

  .form-tip,
  .fetched-comic-info {
    margin-left: 0;
  }

  .fetched-comic-info {
    padding: 8px;
  }

  .fetched-cover {
    width: 64px;
    height: 84px;
  }

  .inline-field-row {
    flex-wrap: wrap;
  }

  .inline-action-btn {
    width: 100%;
    margin-left: 0;
  }

  .cover-row .inline-cover-preview {
    width: 68px;
    height: 68px;
  }

  .episode-input {
    width: 96px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue